import Vue from 'vue';
import qs from 'qs';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import Swal from 'sweetalert2';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

const hasNonLetterOrDigit = (value) => /[^a-zA-Z0-9]/.test(value)
const hasLowercase = (value) => /[a-z]/.test(value)
const hasUppercase = (value) => /[A-Z]/.test(value)

new Vue({
    el: '#app',
    data: {
        model: {},
        requireChangePwd: false,
        redirectLink: '',
        resetModel: {
            Password: '',
            ConfirmPassword: ''
        }
    },
    validations() {
        return {
            resetModel: {
                Password: {
                    required,
                    minLength: minLength(8),
                    hasNonLetterOrDigit,
                    hasLowercase,
                    hasUppercase
                },
                ConfirmPassword: {
                    required,
                    sameAsPassword: sameAs(() => this.resetModel.Password)
                }
            }
        }
    },
    methods: {
        onLogin: function () {
            var _this = this;
            var loading = _this.loading();
            _this.model.__RequestVerificationToken = $('[name="__RequestVerificationToken"]').val();
            axios.post(path('Account/Login'), qs.stringify(_this.model)).then(function (res) {
                if (res.data.IsError) {
                    Swal.fire('Warning Message', res.data.ErrorMessage, 'error');
                } else {
                    _this.redirectLink = res.data.Json.Link;
                    if (res.data.Json.RequireChangePwd) {
                        _this.requireChangePwd = true;
                    } else {
                        window.location = _this.redirectLink;
                    }
                }
            }).finally(() => loading.hide());
        },
        handleChangePwd() {
            var _this = this;
            this.$v.$touch();
            if (!this.$v.$invalid) {
                var loading = _this.loading();
                _this.resetModel.__RequestVerificationToken = $('[name="__RequestVerificationToken"]').val();
                _this.resetModel.UserName = _this.model.UserName;
                axios.post(path('Account/ResetPassword'), qs.stringify(_this.resetModel)).then(function (res) {
                    if (res.data.IsError) {
                        Swal.fire('Warning Message', res.data.ErrorMessage, 'error');
                    } else {
                        window.location = _this.redirectLink;
                    }
                }).finally(() => loading.hide());
            }
        },
        loading: function () {
            return this.$loading.show({
                color: '#0856ab'
            });
        }
    }
});


// WEBPACK FOOTER //
// ./Scripts/js/accounts/login.js